var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 20V16C56.5 14.5855 55.9381 13.2289 54.9379 12.2287C53.9377 11.2285 52.5812 10.6666 51.1667 10.6666H13.8333C12.4188 10.6666 11.0623 11.2285 10.0621 12.2287C9.0619 13.2289 8.5 14.5855 8.5 16V53.3333C8.5 54.7478 9.0619 56.1044 10.0621 57.1045C11.0623 58.1047 12.4188 58.6666 13.8333 58.6666H23.1667M43.1667 5.33331V16M21.8333 5.33331V16M8.5 26.6666H21.8333M47.1667 46.6666L43.1667 43.3333V37.3333M59.1667 42.6666C59.1667 46.9101 57.481 50.9798 54.4804 53.9804C51.4798 56.9809 47.4101 58.6666 43.1667 58.6666C38.9232 58.6666 34.8535 56.9809 31.853 53.9804C28.8524 50.9798 27.1667 46.9101 27.1667 42.6666C27.1667 38.4232 28.8524 34.3535 31.853 31.3529C34.8535 28.3524 38.9232 26.6666 43.1667 26.6666C47.4101 26.6666 51.4798 28.3524 54.4804 31.3529C57.481 34.3535 59.1667 38.4232 59.1667 42.6666Z",
    stroke: "#09090B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.b114577024736978fa09c3af21b245ba.svg";
export { ForwardRef as ReactComponent };